import { useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, FileText, Receipt, ShieldCheck, MessageSquare, Key, Activity, FileCode, LogOut, Menu, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import vietnamLogo from "../assets/vietnam-logo.png";

const navItems = [
  { to: "/admin",              icon: LayoutDashboard, label: "Admin Dashboard",    end: true },
  { to: "/admin/validate",     icon: ShieldCheck,     label: "Validate Data"                },
  { to: "/admin/invoices",     icon: Receipt,         label: "Invoice Generator"            },
  { to: "/admin/clients",      icon: Users,           label: "Clients"                      },
  { to: "/admin/transactions", icon: FileText,        label: "Transactions"                 },
  { to: "/admin/requests",     icon: MessageSquare,   label: "Requests"                     },
  { to: "/admin/credentials",  icon: Key,             label: "Credential Requests"          },
  { to: "/admin/activity",     icon: Activity,        label: "Activity Monitoring"          },
  { to: "/admin/logs",         icon: FileCode,        label: "System Logs"                  },
];

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate("/"); };

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      {sidebarOpen && <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setSidebarOpen(false)} />}

      <aside className={`fixed lg:static inset-y-0 left-0 z-50 w-64 bg-white border-r border-gray-200 flex flex-col transform transition-transform duration-300 ease-in-out ${sidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}>
        <div className="h-16 flex items-center justify-between px-6 border-b border-gray-200">
          <img src={vietnamLogo} alt="Vietnam Airlines" className="h-14 w-auto" />
          <button onClick={() => setSidebarOpen(false)} className="lg:hidden p-1 hover:bg-gray-100 rounded">
            <X className="w-5 h-5" />
          </button>
        </div>

        <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              onClick={() => setSidebarOpen(false)}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                  isActive ? "bg-[#367588] text-white" : "text-gray-700 hover:bg-gray-100"
                }`
              }
            >
              <item.icon className="w-5 h-5 flex-shrink-0" />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-gray-200">
          <button onClick={handleLogout} className="flex items-center gap-3 px-3 py-2.5 text-sm text-gray-700 hover:bg-gray-100 rounded-lg w-full transition-colors">
            <LogOut className="w-5 h-5" />
            Sign Out
          </button>
        </div>
      </aside>

      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="lg:hidden h-16 bg-white border-b border-gray-200 flex items-center justify-between px-4">
          <button onClick={() => setSidebarOpen(true)} className="p-2 hover:bg-gray-100 rounded-lg">
            <Menu className="w-6 h-6" />
          </button>
          <img src={vietnamLogo} alt="Vietnam Airlines" className="h-11 w-auto" />
          <div className="w-10" />
        </header>
        <main className="flex-1 overflow-auto"><Outlet /></main>
      </div>
    </div>
  );
}